document.addEventListener("DOMContentLoaded", function () {
  const productCards = document.querySelectorAll('.product-card');
  const primaryFilters = document.querySelectorAll('.primary-filter');
  const subcategoryGroups = document.querySelectorAll('.subcategory-wrapper');
  const subcategoryFilters = document.querySelectorAll('.subcategory-filter');
  const clearBtn = document.getElementById('clear-filters');

  function normalize(str) {
    return str?.trim().toLowerCase();
  }

  function getCheckedValues(filters) {
    return [...filters].filter(cb => cb.checked).map(cb => normalize(cb.value));
  }

  function updateSubcategoryVisibility() {
    const selectedPrimary = getCheckedValues(primaryFilters);

    subcategoryGroups.forEach(group => {
      const parent = normalize(group.getAttribute('data-parent'));
      group.style.display = selectedPrimary.includes(parent) ? 'block' : 'none';
    });
  }

  function filterProducts() {
    const selectedPrimary = getCheckedValues(primaryFilters);
    const selectedSubcats = getCheckedValues(subcategoryFilters);

    productCards.forEach(card => {
      const primary = normalize(card.getAttribute("data-primary"));
      const subcat = normalize(card.getAttribute("data-subcategory"));

      const matchesPrimary = selectedPrimary.length === 0 || selectedPrimary.includes(primary);
      const matchesSubcat = selectedSubcats.length === 0 || selectedSubcats.includes(subcat);

      card.style.display = (matchesPrimary && matchesSubcat) ? "" : "none";
    });

    updateSubcategoryVisibility();
  }

  [...primaryFilters, ...subcategoryFilters].forEach(cb => {
    cb.addEventListener("change", filterProducts);
  });

  clearBtn?.addEventListener("click", function () {
    [...primaryFilters, ...subcategoryFilters].forEach(cb => (cb.checked = false));
    subcategoryGroups.forEach(group => (group.style.display = "none"));
    filterProducts();
  });

  filterProducts(); // Initial call
});
